export default function Django_Create_App() {
  return <div>Django_Create_App Component</div>;
}
